import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Users',
    data () {
        return {
            admin:{},
            users: {},
            wallet_transactions:{},
            wallet_transaction:{},
            total_rewards_spent:0,
            disable_btn:false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and contracts
       

    //wallet
    setWalletTransaction(txn){
        this.wallet_transaction = txn;
    },
    
    getWalletRewardsTransactions() {
        service.getRewardsTransactions(this).then(data => {
             if(data.body.status == 200) {
                 this.total_rewards_spent = data.body.total_rewards_spent;
             }
             this.wallet_transactions = data.body.data;
         }).catch((err) => {
             if(err) {
                 toastr.error('Sorry, could not process information', 'Warning!');
             }
         })
    },

    formatCurrency(currency){
        currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
        return currency.replace("NGN", ""); //strip off NGN
    },

    
    //wallet

    
        
    },
    created: function(){
        this.preset();
        this.getWalletRewardsTransactions();
    }
}


// WEBPACK FOOTER //
// ./src/components/Rewards/script.js